<template>
    <div class="contents-block -home">
      <div class="home-top">
        <fade-in-component>
        <HomeTopCenter></HomeTopCenter>
        </fade-in-component>
      </div><!-- .home-top -->

      <HomeTopBg></HomeTopBg>

      <fade-in-component>
      <section class="home-sec">
        <h2 class="secttl">
          「SALES SCOPE」は<br>人気10業界の<br class="_tablet">セールスパーソンを徹底解剖
        </h2>
        <p class="sectxt _mb40">
          仕事内容をはじめ、業界風土や仕事へのモチベーションなど、実際に働いてみないとなかなかわからない<br>
          セールスパーソンたちの本音をデータによって紐解いていきます。<br>
          転職したい職種や今の自分の職種など、 興味のある仕事の情報収集にお役立てください。
        </p>
        <ul class="lead-icons">
          <li class="list"><router-link to="staffagency" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_human.svg" alt="" class="liimg"></span><p class="litxt">人材</p></router-link></li>
          <li class="list"><router-link to="bank" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_bank.svg" alt="" class="liimg"></span><p class="litxt">金融</p></router-link></li>
          <li class="list"><router-link to="it" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_it.svg" alt="" class="liimg"></span><p class="litxt">IT</p></router-link></li>
          <li class="list"><router-link to="foodcompany" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_food.svg" alt="" class="liimg"></span><p class="litxt">食品</p></router-link></li>
          <li class="list"><router-link to="cardealer" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_car.svg" alt="" class="liimg"></span><p class="litxt">自動車<br>ディーラー</p></router-link></li>
          <li class="list"><router-link to="shosha" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_syousya.svg" alt="" class="liimg"></span><p class="litxt">商社</p></router-link></li>
          <li class="list"><router-link to="insurance" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_hoken.svg" alt="" class="liimg"></span><p class="litxt">保険</p></router-link></li>
          <li class="list"><router-link to="estate" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_estate.svg" alt="" class="liimg"></span><p class="litxt">不動産</p></router-link></li>
          <li class="list"><router-link to="mr" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_mr.svg" alt="" class="liimg"></span><p class="litxt">MR</p></router-link></li>
          <li class="list"><router-link to="securities" class="lilink"><span class="imgcv"><img src="../assets/img/cmnsvg/icon_money.svg" alt="" class="liimg"></span><p class="litxt">証券</p></router-link></li>
        </ul>
      </section>
      </fade-in-component>

      <fade-in-component>
        <section class="home-sec _pb10">
          <h2 class="secttl">
            営業職を対象に<br class="_tablet">人物特性調査を実施
          </h2>
          <div class="hsec2inner">
            <div class="inleft">
              <p class="sectxt _txtL _mb40">
                業界別に営業職に人物特性を測定するアンケートを実施し、<br>
                性格、キャリア志向性、思考行動傾向について調査をおこないました。
              </p>
              <p class="blntxt -t1">イメージ通りの業界もあれば、意外な結果が見られることも。</p>
              <p class="blntxt -t2">ひと括りにされがちな営業職のイメージですが、<br>業界ごとにどのような特徴が見られるのでしょうか？</p>
            </div><!-- inleft -->
            <div class="inright">
              <img src="../assets/img/home/graph.png" alt="営業職対象の人物特性調査" class="imggraph">
            </div><!-- inright -->
            <div class="inbtm">
              <p class="ibtxt">調査期間：2020年7月</p>
              <p class="ibtxt">調査方法：インターネット調査（適性検査「SALES SCORE」利用者含む）</p>
              <p class="ibtxt">回答者数：879名</p>
            </div>
          </div><!-- hsec2inner -->
        </section>
      </fade-in-component>

      <section class="home-sec2">

        <fade-in-component>
        <div class="hs2header">
          <h2 class="hsec2ttl"><span class="hsec2h2in">データで見るセールスタイプ</span></h2>
        </div>
        </fade-in-component>

        <fade-in-component>
          <h3 class="ttlyb"><span class="ttlybtxt">業界同士の比較をのぞく</span></h3>
          <div class="hsec2inner01">

            <ul class="contents-ul">
              <li class="list -l01">
                <router-link to="/decision" class="link">
                  <div class="typeimg"><img src="../assets/img/cmn/flag.svg" alt="意思決定にみられる特徴" class="img"></div>
                  <p class="typetxt">意思決定に<br>みられる特徴</p>
                  <span class="linkbtn">詳しく見る</span>
                </router-link>
              </li>
              <li class="list -l02">
                <router-link to="/stereotype" class="link">
                  <div class="typeimg"><img src="../assets/img/cmn/tie.svg" alt="「できる営業像」の思い込み" class="img"></div>
                  <p class="typetxt">「できる営業像」<br>の思い込み</p>
                  <span class="linkbtn">詳しく見る</span>
                </router-link>
              </li>
              <li class="list -l03">
                <router-link to="/highperformer" class="link">
                  <div class="typeimg"><img src="../assets/img/cmn/mountain.svg" alt="ハイパフォーマー特性" class="img"></div>
                  <p class="typetxt">ハイパフォーマー特性</p>
                  <span class="linkbtn">詳しく見る</span>
                </router-link>
              </li>
              <li class="list -l04">
                <router-link to="/relationship" class="link">              
                  <div class="typeimg"><img src="../assets/img/cmn/hart.svg" alt="対人関係にみられる特徴" class="img"></div>
                  <p class="typetxt">対人関係に<br>みられる特徴</p>
                  <span class="linkbtn">詳しく見る</span>
                </router-link>
              </li>
            </ul>
          </div>
        </fade-in-component>

        <fade-in-component>
          <h3 class="ttlyb _mb30"><span class="ttlybtxt">業界ごとの詳細をのぞく</span></h3>
          <DetailsList></DetailsList>
        </fade-in-component>

      </section>

      <section class="bottom-sec">
        <fade-in-component>
          <header class="btmsechd">
            <h2 class="btmttl">CONTENTS</h2>
            <p class="hdtxt">関連コンテンツ</p>
          </header>
        </fade-in-component>
        <fade-in-component>
          <div class="btmsecinner">
            <div class="box">
              <h3 class="sitettl">SALES SCORE</h3>
              <a href="/" class="imglink" target="_blank">
				<img class="img retina" src="../assets/img/home/sscore-img.png" alt="SALES SCORE" draggable="false"  srcset="../assets/img/home/sscore-img@2x.png 2x">
              </a>
              <a href="/" class="linkbtn" target="_blank">詳しく見る</a>
            </div><!-- .inleft -->
            <div class="box">
              <h3 class="sitettl">SALES SOLDER</h3>
              <a href="/soldier/" class="imglink" target="_blank">
                <img class="img" src="../assets/img/home/ssolder-img.jpg" alt="SALES SOLDER">
                <div class="leadtxt -lt2">
                  <p class="lead01"><span class="ltin">1分でわかる</span><span class="ltin">あなたの営業タイプ診断</span></p>
                </div>
              </a>
              <a href="/soldier/" class="linkbtn" target="_blank">詳しく見る</a>
            </div><!-- .inright -->

          </div><!-- .btmsecinner -->
          </fade-in-component>
      </section> <!-- . bottom-sec -->

    </div><!-- .contents-block -->
</template>

<script>
import HomeTopCenter from "../components/HomeTopCenter.vue";
import HomeTopBg from "../components/HomeTopBg.vue";
import FadeInComponent from "../components/FadeInComponent.vue";
import DetailsList from "../components/DetailsList.vue";

export default {
  components: {
    // MainSlider,
    HomeTopCenter,
    HomeTopBg,
    FadeInComponent,
    DetailsList
  },
  data() {
    return {
      title: "SALES SCOPE",
      text: "index",
    };
  },
  metaInfo: {
    titleTemplate: "人気10業界！営業職の特徴を人物特性からのぞいてみた | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
      amp: false,
    },
    meta: [

/*      
      { property: 'og:site_name', content: 'SALES SCOPE' },
      { property: 'og:type', content: 'website|article' },
      { property: 'og:title', content: '人気10業界！営業職の特徴を人物特性からのぞいてみた | SALES SCOPE' },
      { property: 'og:description', content: '「できる営業像」は業界ごとに違う？「SALES SCOPE（セールススコープ）」ではセールスパーソンをちょっと遠くからのぞいてみました。不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。ステレオタイプな印象から、ハイパフォーマーの思いがけない側面まで、多様な営業職を一緒に見ていきましょう。' },
      { property: 'og:url', content: 'https://sales-score.jp/scope/' },
      { property: 'og:image', content: 'https://sales-score.jp/scope/ogp/OGP.png' },
*/

      { name: 'application-name', content: 'SALES SCOPE' },
      { name: 'msapplication-square70x70logo', content: 'https://sales-score.jp/scope/favicon/site-tile-70x70.png' },
      { name: 'msapplication-square150x150logo', content: 'https://sales-score.jp/scope/favicon/site-tile-150x150.png' },
      { name: 'msapplication-wide310x150logo', content: 'https://sales-score.jp/scope/favicon/site-tile-310x150.png' },
      { name: 'msapplication-square310x310logo', content: 'https://sales-score.jp/scope/favicon/site-tile-310x310.png' },

    ],
     link: [
      { rel: 'icon', type: 'image/x-icon', href: '/scope/favicon.ico' },
      { rel: 'apple-touch-icon', sizes: '180x180', href: '/scope/favicon/apple-touch-icon.png' },

    ]
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  animation: sec-fade 0.3s;
}

@keyframes sec-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>